import React, { useState } from "react";
import { Card, Tabs } from "antd";
import List from './list/List';
import Add from './add/Add';
const TabPane = Tabs.TabPane;


const StandardsPage = () => {
  const [activeTab, setActiveTab] = useState("1");
  const [StandardsEditData, setStandardsEditData] = useState(null);
  const [StandardsEditFlag, setStandardsEditFlag] = useState(false);
  const callback = (key, data = null, currentPage = 1) => {
    setActiveTab(key);
    if (data && key === "2") {
      setStandardsEditData(data);
      setStandardsEditFlag(true);
    } else if (key === "2") {
      setStandardsEditFlag(false);
      setStandardsEditData(null);
    }
  };

  return (
    <Card className="gx-card" title="استانداردها">
      <Tabs activeKey={activeTab} onChange={callback}>
        <TabPane tab="لیست استانداردها" key="1">
          <List changeTabEvent={callback} />
        </TabPane>
        <TabPane tab="افزودن / ویرایش استاندارد" key="2">
          <Add fields={StandardsEditData} editSection={StandardsEditFlag} changeTabEvent={callback} />
        </TabPane>
      </Tabs>
    </Card>
  );
};

export default StandardsPage;
